export default __webpack_public_path__ + "static/media/October2009.0f316333.png";